import { AuthMessageType, ClientType, ConnectionMessage, ConnectionMessageType, websocket } from '@playcastdotio/Messaging';
import { getPersistentPlayerId } from '../../..';
import { authStore } from '../../../stores/globalStores';

// Flag to track if auth is pending
let isAuthPending = false;

// Function to be called when AUTH_SUCCESS is received
export const onAuthSuccess = (): boolean => {
  isAuthPending = false;

  // Check if we have a token now that needs to be upgraded
  const token = authStore.currentState.accessToken;
  if (token && window.pendingAuthUpgradeSocket) {
    console.log('Auth success, sending upgrade with token');
    const upgradeMsg = websocket.generators.auth(AuthMessageType.AUTH_UPGRADE, {
      clientType: ClientType.PLAYER,
      persistentId: getPersistentPlayerId(),
      tokenJwt: token,
    });
    window.pendingAuthUpgradeSocket.send(JSON.stringify(upgradeMsg));
    window.pendingAuthUpgradeSocket = null;
    return true;
  }
  return false;
};

// Declare global pendingAuthUpgradeSocket to store socket reference
declare global {
  interface Window {
    pendingAuthUpgradeSocket: WebSocket | null;
  }
}

// Initialize the global variable
if (typeof window !== 'undefined') {
  window.pendingAuthUpgradeSocket = null;
}

export const handleConnectionMessage = (message: ConnectionMessage, rawSocket: WebSocket | null) => {
  console.log('Connection message:', message);

  switch (message.type) {
    case ConnectionMessageType.CONN_AUTH_REQUIRED: {
      console.log('Auth required');
      const token = authStore.currentState.accessToken;
      const msg = websocket.generators.auth(AuthMessageType.AUTH_REQUEST, {
        clientType: ClientType.PLAYER,
        persistentId: getPersistentPlayerId(),
        tokenJwt: token || undefined,
      });

      if (!token) {
        // Set auth pending flag
        isAuthPending = true;

        // Store socket reference for later upgrade
        if (typeof window !== 'undefined') {
          window.pendingAuthUpgradeSocket = rawSocket;
        }

        // Set up listener for token availability
        const authlistener = authStore.addListener((state) => {
          if (state.accessToken) {
            // Only send upgrade if auth is no longer pending
            if (!isAuthPending && window.pendingAuthUpgradeSocket) {
              console.log('Token available and auth not pending, sending upgrade');
              const upgradeMsg = websocket.generators.auth(AuthMessageType.AUTH_UPGRADE, {
                clientType: ClientType.PLAYER,
                persistentId: getPersistentPlayerId(),
                tokenJwt: state.accessToken,
              });
              window.pendingAuthUpgradeSocket.send(JSON.stringify(upgradeMsg));
              window.pendingAuthUpgradeSocket = null;
            }
            authStore.removeListener(authlistener);
          }
        });
      }
      // Bypass ready check
      rawSocket?.send(JSON.stringify(msg));
      break;
    }
  }
};
